<template>
	<div class="col-xl-4">
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-6">

						<h4>Bienvenido(a)</h4>
						<p class="text-muted" >
							{{ jsonCoordinadora.nombre }} {{ jsonCoordinadora.apellido }}
							{{ jsonCoordinadora.email }}
						</p> 
					</div>
					<div class="col-5 ml-auto">
						<div>
							<img
								src="//static.vgroup.cl/lms5/archivo/2020/07/coordinadora.png.png"
								alt=""
								class="img-fluid"
								style="max-width: 80%;"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card">
			<div class="card-body">
				<div class="media-body" >
					<h5 >Campus asociados</h5>
					<p class="card-title-desc">
						A continuación, verás un listado de todos los campus en los cuales estás asignado como administrador(a).
					</p>
					<!-- <table class="table">
						<tbody>
							<tr v-for="(campus, index) in dataCampus" :key="index">
								<td># {{ campus.idCampus }} <span @click="setGlobalSelection(campus)" style="cursor:pointer;">{{ campus.titulo }}</span></td>
							</tr>
						</tbody>
					</table> -->
					<div class="row">
                           <div v-for="(campus, index) in dataCampus" :key="index" class="col-12 mb-3">
							   # {{ campus.idCampus }} <span @click="setGlobalSelection(campus)" style="cursor:pointer;">{{ campus.titulo }}</span>
							   <span style="float: right;" v-show="campusSeleccionadoMulti.idCampus == campus.idCampus">Seleccionado <i class="fas fa-check" style="color:green;"></i></span>
						   </div>
					</div>
				</div>
			</div>
		</div>
		<div class="card d-none">
			<div class="card-body">
				<div class="media-body"> 
					<h5 >Proximos cursos</h5>
					<p class="card-title-desc">
						Éstos son los últimos 10 cursos que iniciarán o iniciaron.
					</p>
	
					<table class="table b-table mt-3 table-striped table-hover border">
						<thead>
							<tr>
								<th scope="col">Curso</th>
								<th scope="col" style="width: 120px;">Fecha Inicio</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(curso, index) in jsonUltimosCursos" :key="index">
								
								<td># {{ curso.idCurso }} {{curso.tituloCurso}}</td>
								<td>{{ fechaConversion(curso.FechaInicio) }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <PuSkeleton v-else :count="5" /> -->
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
	data:()=>({
			coordinadora: [],
			loadCampus:true,
			loadUltimosCursos:true,
			ultimosCursos:[],
	}),
	computed:{
		...mapState('alumno',['jsonCoordinadora']),
		...mapState('campus',['dataCampus']),
		...mapState('curso',['titulosCurso']),
		...mapState('curso',['jsonUltimosCursos']),
		...mapState("curso",["campusSeleccionadoMulti"]),
	},
	methods: {
		...mapActions("curso", ["updateOnlyCurso"]),
		...mapActions("curso", ["updateLargoDisponiblesAction"]),
		...mapActions("curso", ["updateCurrentArchivadosAction"]),
		...mapActions("curso",["updateTotalAlumnosCampusAction"]),
		...mapActions("curso",["setCampusSeleccionadoMultiAction"]),
		...mapActions("curso", ["setCurrentSelector"]),
		...mapActions("curso",["filterCursosByCampusAction"]),
		fechaConversion(fechaCurso) {
			var objDate = new Date(fechaCurso);
			let dia = objDate.toLocaleDateString("es-ES", { day: "numeric" }),
				mes = objDate.toLocaleDateString("es-ES", { month: "long" }),
				año = objDate.toLocaleDateString("es-ES", { year: "numeric" });

			return dia + " " + mes + " " + año;
		},
		setGlobalSelection(campus){
			//set cursos de ese campus
			this.setCurrentSelector("disponibles");
			this.setCampusSeleccionadoMultiAction(campus);
			this.filterCursosByCampusAction({
					campusSeleccionado:this.campusSeleccionadoMulti,
					titulosCurso:this.titulosCurso,
					filter:true
			});
		}
	},
	created(){
		//this.getInfoLogeado();
		//this.getCursosCoordinadora();
	},
};
</script>
